import { Box, Typography } from '@mui/material';
import React from 'react';

export const ZeyomPage: React.FC = () => {
  return (
    <Box
      sx={{
        height: 'calc(100vh - 64px)',
        display: 'flex',
        flexDirection: 'column',
        p: 4,
      }}
    >
      <Typography variant="h4" gutterBottom>
        Zeyom Settings
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
        Hidden developer settings page for testing experimental features.
      </Typography>
    </Box>
  );
};
